<template>
    <cadastro-simples-list
        endpoint="raca"
        rota-base="/admin/raca"
        titulo="RAÇAS / COR"
        titulo-singular="Raça/Cor"
        :colunas-extras='[{"campo":"cod_censo","label":"Código INEP","tipo":"string"}]'>
    </cadastro-simples-list>
</template>

<script>
import CadastroSimplesList from '@/components/cadastros-auxiliares/cadastro-simples-list.vue'
export default { components: { CadastroSimplesList } }
</script>
